import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import bsulogo from '../assets/images/bsu-logo.svg';

class PageNotFound extends Component {
  render() {
    return (
      <section className="pagenotfound-container">
      <h1>404</h1>
      <h2>Tap Your Way Back!</h2>
      
       

        <footer className="page-foot">

        <Link className="button-primary" to="/"> Back to Start</Link>
       <a href="http://cms.bsu.edu/academics/collegesanddepartments/online" target="_blank" > <img src={bsulogo} alt="Ball State University We Fly"/></a>



              
                </footer>
      </section>
    );
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js